import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';
import type { FeedbackKind } from '@/api/generated';

export const feedbackKeys = {
  all: ['feedback'] as const,
  list: (query: string, kinds: readonly FeedbackKind[], pageSize: number, pageToken: string) =>
    [...feedbackKeys.all, 'list', query, [...kinds].join(','), pageSize, pageToken] as const,
};

export function useFeedback(
  query = '',
  kinds: readonly FeedbackKind[] = [],
  pageSize = 25,
  pageToken = '',
) {
  return useQuery({
    queryKey: feedbackKeys.list(query, kinds, pageSize, pageToken),
    queryFn: () =>
      adminClient.listFeedback({
        query: query || undefined,
        kinds: [...kinds],
        pageSize,
        pageToken: pageToken || undefined,
      }),
  });
}
